import React, { Suspense } from 'react'

import { Skeleton } from '@/components'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'

import EnvBadge from './env-badge'
import Logo from './logo'

const Navbar = React.lazy(() => import('./navbar'))
const UserArea = React.lazy(() => import('./user-area'))

const NavbarSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
  </div>
)

export function Sidebar() {
  const { user } = useAuthStore()

  return (
    <div className="z-10 h-full w-[240px] select-none bg-zinc-900">
      {/* Sticky */}
      <div className="sticky top-0 flex h-screen flex-col p-4">
        {/* Header */}
        <div className="flex items-center justify-between gap-2 border-b border-b-zinc-700 pb-2">
          <Logo />
          <EnvBadge />
        </div>

        {/* Body */}
        {user && (
          <div className="overflow-y-auto text-white">
            <Suspense fallback={<NavbarSkeleton />}>
              <Navbar />
            </Suspense>
          </div>
        )}

        {/* Spacer */}
        <div className="flex-1"></div>

        {/* Footer */}
        <Suspense fallback={<Skeleton className="h-8 bg-zinc-600" />}>
          <UserArea />
        </Suspense>
      </div>
    </div>
  )
}
